import { get, post, put, del } from './apiService';

/**
 * Get all screens
 * @returns {Promise<Array>} List of screens
 */
export async function getScreens() {
  return await get('/screens');
}

/**
 * Add screen to organization
 * @param {string} org_id - Organization ID
 * @param {string} screen_id - Screen ID
 * @returns {Promise<object>} Created screen organization
 */
export async function addScreenOrganization(org_id, screen_id) {
  return await post('/organizations/screens', {
    screen_id,
    organization_id: org_id,
  });
}

/**
 * Remove screen from organization
 * @param {string} org_id - Organization ID
 * @param {string} screen_id - Screen ID
 * @returns {Promise<object>} Response
 */
export async function removeScreenOrganization(org_id, screen_id) {
  return await del('/organizations/screens', {
    screen_id,
    organization_id: org_id,
  });
}

/**
 * Update order items for a screen
 * @param {string} order_id - Order ID
 * @param {string} screen_id - Screen ID
 * @param {Array<string>} orderItemIdList - List of order item IDs
 * @returns {Promise<object>} Response
 */
export async function updateOrderItems(order_id, screen_id, orderItemIdList) {
  return await put(
    '/order/items',
    {
      current_screen_id: screen_id,
      order_id: order_id,
      order_items: orderItemIdList,
    },
    { requireAuth: false }
  );
}
